import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client.ts';

export function Settings() {
  const [activeTab, setActiveTab] = useState('icp');
  
  const { data: settings, isLoading } = useQuery({
    queryKey: ['settings'],
    queryFn: () => api.getSettings()
  });

  if (isLoading) return <div>Loading...</div>;

  return (
    <div style={{ padding: '24px' }}>
      <h1>Settings</h1>
      
      <div style={{ display: 'flex', gap: '16px', borderBottom: '1px solid #334155', marginBottom: '24px' }}>
        {['icp', 'scoring', 'thresholds', 'cost', 'campaigns'].map(tab => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            style={{
              padding: '12px 16px',
              background: 'none',
              border: 'none',
              borderBottom: activeTab === tab ? '2px solid #2563eb' : '2px solid transparent',
              color: activeTab === tab ? '#2563eb' : '#666',
              cursor: 'pointer',
              textTransform: 'capitalize',
              fontWeight: activeTab === tab ? 'bold' : 'normal'
            }}
          >
            {tab}
          </button>
        ))}
      </div>

      <div style={{ background: '#1e293b', padding: '24px', borderRadius: '8px', border: '1px solid #334155' }}>
        {activeTab === 'icp' && (
          <div>
            <h3>Ideal Customer Profile (ICP)</h3>
            <pre style={{ background: '#334155', padding: '16px', borderRadius: '4px' }}>
              {JSON.stringify(settings?.icp, null, 2)}
            </pre>
            <p style={{ color: '#94a3b8', fontSize: '14px' }}>Use the CLI or KV dashboard to update full ICP config.</p>
          </div>
        )}

        {activeTab === 'scoring' && (
          <div>
            <h3>Scoring Weights</h3>
            <div style={{ display: 'grid', gap: '12px', maxWidth: '500px' }}>
              {Object.entries(settings?.scoring || {}).map(([key, val]) => (
                <div key={key} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ fontFamily: 'monospace' }}>{key}</span>
                  <input type="number" defaultValue={val as number} style={{ width: '60px', padding: '4px' }} />
                </div>
              ))}
            </div>
          </div>
        )}

        {activeTab === 'thresholds' && (
          <div>
            <h3>Thresholds</h3>
            <div style={{ display: 'grid', gap: '12px', maxWidth: '500px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>Filter Threshold</span>
                <input type="number" defaultValue={settings?.thresholds?.filterScore} style={{ width: '80px', padding: '4px' }} />
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>Qualification Threshold</span>
                <input type="number" defaultValue={settings?.thresholds?.qualificationScore} style={{ width: '80px', padding: '4px' }} />
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>Intent Handoff Threshold</span>
                <input type="number" defaultValue={settings?.thresholds?.intentHandoff} style={{ width: '80px', padding: '4px' }} />
              </div>
            </div>
          </div>
        )}

        {activeTab === 'cost' && (
          <div>
            <h3>Cost Controls</h3>
            <pre style={{ background: '#334155', padding: '16px', borderRadius: '4px' }}>
              {JSON.stringify(settings?.costControls, null, 2)}
            </pre>
          </div>
        )}

        {activeTab === 'campaigns' && (
          <div>
            <h3>Campaigns</h3>
            <p>Campaigns govern routing and config context.</p>
            <div style={{ padding: '16px', background: '#0f172a', border: '1px solid #334155', borderRadius: '4px' }}>
              <strong>Active Campaign:</strong> {settings?.campaigns?.[0]?.id} ({settings?.campaigns?.[0]?.name})
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
